<div class="wrapper" [ngClass]="{ open }">
  <div class="container">
    <header>
      <div class="overlay">
        <ng-container *ngIf="user">
          <div class="sign-out">
            <a routerLink="/logout" (click)="closeMenuHandler()">
              Log out
              <app-shared-icon
                name="log-out-white"
                class="icon"
                [size]="15"
              ></app-shared-icon>
            </a>
          </div>
          <a routerLink="/profile/account" (click)="closeMenuHandler()">
            <img src="/assets/images/user.png" alt="user icon" />
          </a>
          <a
            *ngIf="user"
            routerLink="/profile/account"
            (click)="closeMenuHandler()"
          >
            <div class="name truncate">
              {{ user.firstName }} {{ user.surname }}
            </div>
            <div class="email truncate">{{ user.email }}</div>
          </a>
        </ng-container>
        <div class="sign-in" *ngIf="!user">
          <div class="link" (click)="showSignInModal()">
            <app-shared-icon
              name="user-white"
              class="icon"
              [size]="20"
            ></app-shared-icon>
            Sign in
          </div>
        </div>
      </div>
    </header>

    <div class="links-container">
      <app-profile-sidebar
        [embed]="true"
        width="auto"
        [showMenuLinks]="true"
      ></app-profile-sidebar>
    </div>

    <div class="support">
      <div>
        For support:
        <a href="mailto:help@rebuilt.com">{{ 'help@rebuilt.com' }}</a>
      </div>
    </div>

    <footer>
      <div>
        &copy; {{ year }}
        <a href="https://rebuilt.com" target="_blank">Rebuilt</a> - All rights
        reserved.
      </div>
    </footer>
  </div>
</div>
